module.exports = __webpack_public_path__ + "img/moto.6e1af15d.png";